































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CompanyDto from "@/models/Companies/CompanyDto";
import UpdateCompanyGeneralDetailsRequest from "@/models/Companies/UpdateCompanyGeneralDetailsRequest";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { CompanyDetailsModule } from "@/store/modules/companyDetails";
// @ts-ignore

//import { VueTelInputVuetify } from 'vue-tel-input-vuetify';

@Component({
  name: "CompanyGeneralDetailsEdit",
})
export default class extends GiganautVueDialog {

public entity = new CompanyDto();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(
        JSON.stringify(CompanyDetailsModule.currentCompany)
      );
    }
  }

  get loading() {
    return CompanyDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateCompanyGeneralDetailsRequest();
    request.updatedAt = CompanyDetailsModule.currentCompany.updatedAt;
    request.registeredName = this.entity.registeredName;
    request.emailAddress = this.entity.emailAddress;
    request.phoneNumber = this.entity.phoneNumber;
    request.taxNumber = this.entity.taxNumber;
    request.registrationNumber = this.entity.registrationNumber;
    await CompanyDetailsModule.editCompanyGeneralDetails(request);
    this.dialog = false;
  }
}
